/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/

(function () {
  // Add custom code below this line

  class LinkAnimate extends HTMLElement {
    constructor () {
      super();
      const link = this.querySelector('a, marker');
      const style = this.hasAttribute('data-style') ? this.getAttribute('data-style') : 'default';
      let svg = `<svg width="100%" class="custom-stroke" height="100%" viewBox="0 0 141 43" fill="none">
                <path class="path" d="M139.763 5.65956C108.366 0.417575 38.2636 -4.78696 9.03174 16.3307C-27.508 42.7279 69.9314 47.7827 114.591 35.9882C159.251 24.1937 141.387 6.78287 89.4194 7.34451" stroke="black" stroke-linecap="round"/>
              </svg>`;
      switch (style) {
        case 'tabs':
          svg = `<svg width="100%" height="100%" class="custom-stroke" viewBox="0 0 133 49" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M131.777 6.34145C102.186 0.332342 36.1189 -5.63384 8.56949 18.5743C-25.8673 48.8344 65.9641 54.6289 108.053 41.1084C150.143 27.588 133.307 7.62915 84.3305 8.27298" stroke="black" stroke-linecap="round"/>
</svg>`;
          break;
      }
      if (!link || link.querySelector('.custom-stroke')) return;
      link.insertAdjacentHTML('beforeend', svg);
    }
  }

  customElements.define('link-animate', LinkAnimate);

  class Modal {
    constructor (modalElement) {
      if (!modalElement) return;
      this.modalElement = modalElement;
      this.modalBodyElement = this.modalElement.querySelector('[data-modal-body]');
      this.modalClose = this.modalElement.querySelector('[data-modal-close]');
      this.closeHandler = this.close.bind(this);
    }

    isOpened () {
      return this.modalElement.classList.contains('active');
    }

    open () {
      if (!this.isOpened()) {
        this.modalElement.classList.add('active');
        this.modalElement.dispatchEvent(new CustomEvent('modalOpened'));
      }
    }

    close () {
      if (this.isOpened()) {
        this.modalElement.classList.remove('active');
        this.modalElement.dispatchEvent(new CustomEvent('modalClosed'));
      }
    }

    appendContent (contentElements, index = 0) {
      this.modalBodyElement.innerHTML = '';
      contentElements.forEach(element => {
        element.classList.add('modal__item');
        this.modalBodyElement.append(element.cloneNode(true));
      });

      this.modalBodyElement.scrollTo({
        left: this.modalElement.querySelector('.modal__item').offsetWidth * index,
        behavior: 'smooth',
      });
    }

    init () {
      this.modalClose.addEventListener('click', this.closeHandler);
    }

    destroy () {
      this.modalClose.removeEventListener('click', this.closeHandler);
    }
  }

  class ShopTheLook extends HTMLElement {
    constructor () {
      super();
      this.products = this.querySelectorAll('[data-grid-item]');
      this.dots = this.querySelectorAll('[data-dot]');
      this.button = document.querySelector('[data-shop-the-look-button]');
      this.modal = new Modal(this.closest('section').querySelector('[data-modal]'));
      this.swiperElement = this.closest('#shop-the-look-swiper');
      this._onDotClickHandler = this._onDotClick.bind(this);
      this._onClickOutsideHandler = this._onClickOutside.bind(this);
      this._onClickButtonHandler = this._onClickButton.bind(this);
    }

    _setActiveProduct (product) {
      if (!product) return;
      if (this.activeProduct) {
        this.activeProduct.classList.remove('active');
      }
      this.activeProduct = product;
      product.classList.add('active');
    }

    _startSwiper () {
      this._setSwiperStatus('start');
    }

    _stopSwiper () {
      this._setSwiperStatus('stop');
    }

    _setSwiperStatus (action) {
      if (this.swiperElement && this.swiperElement.hasAttribute('autoplay')) {
        const swiper = this.swiperElement.hasOwnProperty('swiper') ? this.swiperElement.swiper : null;
        if (swiper.hasOwnProperty('autoplay')) {
          switch (action) {
            case 'start':
              swiper.autoplay.start();
              break;
            case 'stop':
              swiper.autoplay.stop();
              break;
          }
        }
      }
    }

    _openModal (breakPoint) {
      if (!breakPoint) this.modal.open();
      window.innerWidth <= breakPoint && this.modal.open();
      if (typeof SmartWishlistMain === 'function') {
        SmartWishlistMain();
      }
    }

    _closeModal () {
      this.modal.close();
    }

    _appendModal (input, index = 0) {
      this.modal.appendContent(input, index);
    }

    _onDotClick (event) {
      const index = Number(event.currentTarget.dataset.dot);
      if (this.products[index]) {
        this._setActiveProduct(this.products[index]);
        this._appendModal(this.products, index);
        this._openModal(749);
      }
    }

    _onClickOutside ({ target }) {
      if (!target.closest('[data-dot]') && !target.closest('[data-modal]')) {
        this._closeModal();
      }
    }

    _onClickButton () {
      if (!this.closest('.swiper-slide-active')) return;
      this._appendModal(this.products);
      this._openModal(749);
    }

    addUniqueEventListener (element, event, callback) {
      const listener = `_has${event}Listener`;
      if (!element.hasOwnProperty(listener)) {
        element.addEventListener(event, callback);
        Object.defineProperty(element, listener, {
          value: true,
          writable: false,
          enumerable: false,
          configurable: false,
        });
      }
    }

    connectedCallback () {
      this._setActiveProduct(this.products[0]);
      this.dots.forEach((dot) => {
        dot.addEventListener('click', this._onDotClickHandler);
      });

      this.button.addEventListener('click', this._onClickButtonHandler);

      document.addEventListener('click', this._onClickOutsideHandler);
      this.modal.init();
      if (this.modal?.modalElement) {
        this.addUniqueEventListener(this.modal.modalElement, 'modalOpened', this._stopSwiper.bind(this));
        this.addUniqueEventListener(this.modal.modalElement, 'modalClosed', this._startSwiper.bind(this));
      }
    }

    disconnectedCallback () {
      this.dots.forEach((dot) => {
        dot.removeEventListener('click', this._onDotClickHandler);
      });
      this.button.removeEventListener('click', this._onClickButtonHandler);
      document.removeEventListener('click', this._onClickOutsideHandler);
      if (this.modal?.modalElement) {
        this.modal.modalElement.removeEventListener('modalOpened', this._stopSwiper.bind(this));
        this.modal.modalElement.removeEventListener('modalClosed', this._startSwiper.bind(this));
      }
      this.modal.destroy();
    }
  }

  customElements.define('shop-the-look', ShopTheLook);

  class LineAnimateContainer extends HTMLElement {
    constructor () {
      super();
      this.lines = this.querySelectorAll('em');
      this.observer = new IntersectionObserver(this.callback.bind(this), { threshold: 1 });
      this.props = {
        svg: `<svg width="331" height="3" viewBox="0 0 331 3" fill="none"><path d="M1 2C39.2172 1.24538 158.521 0.188903 330 2" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>`,
        className: 'line-animate',
      };

    }

    connectedCallback () {
      this.lines.forEach((line) => {
        line.insertAdjacentHTML('beforeend', this.props.svg);
        line.classList.add(this.props.className);
      });
      this.observer.observe(this);
    }

    callback (entries) {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this.lines.forEach((item) => {
            item.setAttribute('data-init', 'true');
          });
        }
      });
    }

    disconnectedCallback () {
      this.lines.forEach((line) => {
        line.querySelector('svg')?.remove();
        line.classList.remove(this.props.className);
        line.removeAttribute('data-init');
      });
      this.observer.unobserve(this);
    }
  }

  customElements.define('line-animate-container', LineAnimateContainer);

  document.addEventListener('DOMContentLoaded', async function () {
    const menuDrawerBottom = document.querySelector('.drawer__menu--bottom');
    const menuDrawerBottomHeight = menuDrawerBottom.offsetHeight;
    if (menuDrawerBottom && menuDrawerBottomHeight) {
      document.body.style.setProperty('--menuDrawerBottomHeight', `calc(${menuDrawerBottomHeight}px + 1rem)`);
    }

    // Product media
    document.addEventListener('theme:media:select', (event) => {
      const currentElem = document.querySelector(`.product__images--mobile-slider .product__slide[data-media-id="${event.detail.id}"]`);
      const productMediaList = this.querySelector('.product__images--mobile-slider [data-product-media-list]');
      const index = Array.from(this.querySelectorAll('.product__slide')).
        findIndex(slide => slide.dataset.mediaId === event.detail.id);
      const direction = event.detail.direction;
      if (!productMediaList || !direction || !currentElem) return;
      productMediaList.scrollTo({
        left: direction === 'prev' ? (currentElem.offsetWidth * index) * -1 : currentElem.offsetWidth * index,
        behavior: 'smooth',
      });
    });
    await setHeaderWishListIconStatus();
  });

  async function setHeaderWishListIconStatus (status = false) {
    const wishlistId = getCookie('wishlist_id');
    const customerId = window?.themeVariables?.customerID;
    let count;
    if (status) {
      count = 1;
    } else {
      const url = customerId
        ? `/a/wishlist?type=api&customerid=${customerId}&version=1`
        : `/a/wishlist?type=api&wishlistid=${wishlistId}&version=1`;
      try {
        const response = await fetch(url);
        if (!response.ok) {
          const error = await response.json();
          throw new Error(error?.message ?? 'Unexpected error');
        }
        const result = await response.json();
        count = result?.count || 0;
      } catch (error) {
        console.error(error);
        count = 0;
      }
    }
    document.querySelectorAll('a[href*="pages/wishlist"]').forEach((link) => {
      if (count) {
        link.classList.add('wishlist-not-empty');
      } else {
        link.classList.remove('wishlist-not-empty');
      }
    });

  }

  // Wishlist
  const createEventReducer = (element, events) => {
    const eventTypes = Object.keys(events);
    const handler = (event) => {
      const { type, target } = event;
      const selectors = Object.keys(events[type]);

      selectors.forEach((selector) => {
        if (target.closest(selector)?.matches(selector)) events[type][selector](event);
      });
    };

    eventTypes.forEach((type) => {
      element.addEventListener(type, handler);
    });

    return {
      destroy () {
        eventTypes.forEach((type) => {
          element.removeEventListener(type, handler);
        });
      },
    };
  };

  const getCookie = (name) => document.cookie.split('; ').
    find((cookie) => cookie.startsWith(`${name}=`))?.
    split('=')[1];

  const isLastPage = (items, pageSize, page) => (page + 1) * pageSize >= items.length;

  const paginate = (items, pageSize, pages) => pages.flatMap((page) => {
    const fromIndex = page * pageSize;
    const toIndex = fromIndex + pageSize;

    return items.slice(fromIndex, toIndex);
  });

  const createNumberRange = (length, startAt = 0) => {
    return [...Array(length).keys()].map((index) => index + startAt);
  };

  const removeChildren = (node) => {
    while (node.firstChild) {
      node.removeChild(node.lastChild);
    }
  };

  const createWishlist = async () => {
    function fetchWishlistedVariants (customerId, wishlistId) {
      const url = customerId
        ? `/a/wishlist?type=api&customerid=${customerId}&version=1`
        : `/a/wishlist?type=api&wishlistid=${wishlistId}&version=1`;

      return fetch(url).then((response) => response.json()).then(({ items: wishlistItems }) => {
        const wishlistedVariants = new Map();

        wishlistItems.forEach((item) => {
          wishlistedVariants.set(item.variant_id, {
            id: item.variant_id,
            productId: item.id,
          });
        });

        return wishlistedVariants;
      });
    }

    function fetchShopifyVariantsData (shopifySearchUrl, variants) {
      const variantsIds = variants.map((item) => item?.id);
      const productsIds = variants.map((item) => item?.productId);
      const productsQuery = productsIds.filter((item, index) => productsIds.indexOf(item) === index).
        map((productId) => `id:${productId}`).
        join(' OR ');

      return fetch(`${shopifySearchUrl}?view=wishlist&type=product&q=${productsQuery}`).
        then((response) => response.json()).
        then((searchResults) => {
          return searchResults.variants.filter((variant) => variantsIds.includes(variant.id));
        });
    }

    const customerId = window?.themeVariables?.customerID;
    const searchUrl = window.themeVariables.routes.searchUrl;
    const wishlistId = getCookie('wishlist_id');
    console.log('customerId=', customerId);
    const wishlistedVariants = await fetchWishlistedVariants(customerId, wishlistId);

    return {
      remove (variantId) {
        if (typeof window.RemoveFromSmartWishlist !== 'function') return;
        window.RemoveFromSmartWishlist(wishlistedVariants.get(variantId).productId, variantId);
        wishlistedVariants.delete(variantId);
        setHeaderWishListIconStatus().then();
      },
      async paginate (pages, variantsPerPage) {
        if (wishlistedVariants.size === 0) return [];
        const pagesVariants = await Promise.all(
          pages.map((page) => {
            return fetchShopifyVariantsData(
              searchUrl,
              paginate(Array.from(wishlistedVariants.values()), variantsPerPage, [page]),
            );
          }),
        );

        return pagesVariants.flat();
      },
      isLastPage (page, variantsPerPage) {
        return isLastPage(Array.from(wishlistedVariants.values()), variantsPerPage, page);
      },
      wishlistedVariants,
    };
  };

  const createWishlistSection = async (section, variantsPerPage = 20) => {
    let currentPage = 0;

    const listElement = section.querySelector('[data-list]');
    const controlsElement = section.querySelector('[data-controls]');
    const emptyStateElement = section.querySelector('[data-empty-state]');
    const loadMoreElement = section.querySelector('[data-load-more]');
    const template = section.querySelector('[data-template]').innerHTML;

    function show (element) {
      element.classList.remove('hidden');
    }

    function hide (element) {
      element.classList.add('hidden');
    }

    function createVariantElement (variant, htmlTemplate) {
      const { id, image, title, options, price, form } = variant;
      const variantHTML = htmlTemplate.slice().
        replace('{variant_id}', id).
        replace('{image}', image).
        replace('{title}', title).
        replace('{options}', options).
        replace('{price}', price).
        replace('{form}', form);

      if (!image) variantHTML.replace('wishlist-item__media', 'wishlist-item__media wishlist-item__media--no-image');

      return new DOMParser().parseFromString(variantHTML, 'text/html').querySelector('[data-wishlist-item]');
    }

    function render (wishlist) {
      hide(listElement);
      hide(controlsElement);
      return wishlist.paginate(createNumberRange(currentPage + 1), variantsPerPage).then((variants) => {
        if (variants.length === 0) {
          show(emptyStateElement);
          hide(listElement);
          hide(controlsElement);
          return;
        }

        hide(emptyStateElement);
        removeChildren(listElement);
        variants.forEach((variant) => {
          listElement.append(createVariantElement(variant, template));
        });
        wishlist.isLastPage(currentPage, variantsPerPage) ? hide(loadMoreElement) : show(loadMoreElement);
        show(listElement);
        show(controlsElement);
      }).catch(() => {
        wishlist.isLastPage(currentPage, variantsPerPage) ? hide(loadMoreElement) : show(loadMoreElement);
      });
    }

    const wishlist = await createWishlist();
    const eventReducer = createEventReducer(section, {
      click: {
        '[data-load-more]': () => {
          currentPage += 1;
          render(wishlist);
        },
        '[data-remove]': ({ target }) => {
          const { variantId } = target.closest('[data-remove]').dataset;
          wishlist.remove(variantId);
          render(wishlist);
        },
        '[data-clear]': () => {
          const items = document.querySelectorAll('[data-variant-id]');
          items.forEach((item) => {
            wishlist.remove(item.dataset.variantId);
          });
          window.location.reload();
        },
      },
    });

    render(wishlist);

    return {
      destroy () {
        eventReducer?.destroy();
      },
    };
  };

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-wishlist]').forEach((wishlist) => createWishlistSection(wishlist));
    const wishlistAddedPopupTrigger = () => {
      const wishlistAddedPopupButton = document.getElementById('wishlist-popup');
      if (wishlistAddedPopupButton) wishlistAddedPopupButton.click();
    };
    window.SWCallbackExpressWishlistProductItemRemoved = () => {setHeaderWishListIconStatus().then();};
    window.SWCallbackExpressWishlistProductItemAdded = () => {
      wishlistAddedPopupTrigger();
      setHeaderWishListIconStatus(true).then();
    };
    window.SWCallbackCustomerWishlistProductItemAdded = () => {
      wishlistAddedPopupTrigger();
      setHeaderWishListIconStatus(true).then();
    };
    window.SWCallbackCustomerWishlistProductItemRemoved = () => {setHeaderWishListIconStatus().then();};
  });

  // End Wishlist

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
